import { apiRequest } from '../../../../shared/api/index.js';

/**
 * A 204 carries no body, so there is nothing to run a schema over. The server answers 409 when a
 * payment still points at the category; the caller turns that into the offer to archive it.
 */
export const deleteCategory = async (id: string): Promise<void> => {
  await apiRequest<void>(`/categories/${id}`, { method: 'DELETE' });
};
